import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles (core + any modules you use)
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

// Import Swiper modules
import { Navigation, Autoplay } from 'swiper/modules';

function Clients() {
  return (
    <div id="clients" className="clients section">
      <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Navigation, Autoplay]}    // Include modules here
          navigation                          // Enable navigation (arrows)
          autoplay={{                         // Enable autoplay
            delay: 3000,                      // 3-second delay
            disableOnInteraction: false       // Don't stop autoplay on user interactions
          }}
          speed={800}                         // 800ms transition speed
          loop={true}                         // Loop back to first slide
          spaceBetween={10}
          slidesPerView={1}
          breakpoints={{
            600: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 5,
            },
          }}
          className="clients-slider"
        >
          {/* SwiperSlide components */}
          <SwiperSlide>
            <img src="./assets/images/client-1.png" className="img-fluid" alt="Client 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-2.png" className="img-fluid" alt="Client 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-3.png" className="img-fluid" alt="Client 3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-4.png" className="img-fluid" alt="Client 4" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-5.png" className="img-fluid" alt="Client 5" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-6.png" className="img-fluid" alt="Client 6" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-7.png" className="img-fluid" alt="Client 7" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-8.png" className="img-fluid" alt="Client 8" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-9.png" className="img-fluid" alt="Client 9" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-10.png" className="img-fluid" alt="Client 10" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-11.png" className="img-fluid" alt="Client 11" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="./assets/images/client-12.png" className="img-fluid" alt="Client 12" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

export default Clients;

